import { render, staticRenderFns } from "./infoPage.vue?vue&type=template&id=436d6c08&scoped=true&"
import script from "./infoPage.vue?vue&type=script&lang=js&"
export * from "./infoPage.vue?vue&type=script&lang=js&"
import style0 from "./infoPage.vue?vue&type=style&index=0&id=436d6c08&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436d6c08",
  null
  
)

export default component.exports